import { render } from "./OAuthCallback.vue?vue&type=template&id=36c8d700&scoped=true"
import script from "./OAuthCallback.vue?vue&type=script&lang=js"
export * from "./OAuthCallback.vue?vue&type=script&lang=js"

import "./OAuthCallback.vue?vue&type=style&index=0&id=36c8d700&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36c8d700"]])

export default __exports__